import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { TOURNAMENT } from "@/data/tournament";

const SECTIONS = [
  {
    title: "1. ¿Qué son las cookies?",
    body: `Las cookies son pequeños archivos de texto que los sitios web almacenan en el dispositivo del usuario (ordenador, móvil o tablet) al visitarlos. Sirven para recordar información sobre la visita, como preferencias o datos técnicos necesarios para el funcionamiento del sitio. Además de las cookies, existen tecnologías similares como el almacenamiento local del navegador (localStorage / sessionStorage), a las que también se aplica esta política.`,
  },
  {
    title: "2. Cookies que utiliza este sitio web",
    body: `PROXIMA LEAGUE utiliza únicamente cookies y tecnologías de almacenamiento estrictamente necesarias para el correcto funcionamiento del sitio web:

• Almacenamiento técnico de sesión: se utiliza exclusivamente para el funcionamiento interno de la web (por ejemplo, el acceso al área de administración de la organización). No contiene datos de navegación del visitante.

Este sitio web NO utiliza:
• Cookies de análisis o medición de audiencia.
• Cookies publicitarias o de seguimiento.
• Cookies de terceros con fines comerciales.`,
  },
  {
    title: "3. Base legal",
    body: `De conformidad con el artículo 22.2 de la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), las cookies y tecnologías estrictamente necesarias para la prestación del servicio expresamente solicitado por el usuario están exentas de la obligación de obtener consentimiento previo. Dado que este sitio solo emplea este tipo de tecnologías, no se requiere banner de consentimiento.

Si en el futuro se incorporasen cookies de análisis o publicidad, esta política se actualizará y se solicitará el consentimiento del usuario conforme a la normativa vigente (LSSI-CE y Reglamento General de Protección de Datos — RGPD).`,
  },
  {
    title: "4. Cómo gestionar o eliminar las cookies",
    body: `El usuario puede configurar su navegador para bloquear o eliminar las cookies y el almacenamiento local en cualquier momento. A continuación se indican los enlaces de ayuda de los principales navegadores:

• Google Chrome: Configuración → Privacidad y seguridad → Cookies.
• Mozilla Firefox: Ajustes → Privacidad y seguridad.
• Safari: Preferencias → Privacidad.
• Microsoft Edge: Configuración → Cookies y permisos del sitio.

Tenga en cuenta que el bloqueo de las tecnologías estrictamente necesarias puede afectar al correcto funcionamiento de algunas partes del sitio.`,
  },
  {
    title: "5. Actualizaciones de esta política",
    body: `PROXIMA LEAGUE puede modificar esta Política de Cookies en función de exigencias legislativas o técnicas. Se recomienda al usuario revisarla periódicamente. La fecha de la última actualización figura al pie de esta página.`,
  },
  {
    title: "6. Contacto",
    body: `Para cualquier duda sobre esta Política de Cookies, puede contactar con la organización en ${TOURNAMENT.contactEmail}.`,
  },
];

export default function CookiePolicyPage() {
  return (
    <div className="bg-[#050505] text-white min-h-screen" data-testid="cookie-policy-page">
      <Navbar />
      <main className="pt-16">
        <section className="relative bg-[#070707] py-24 sm:py-28 border-t border-white/5">
          <div className="max-w-5xl mx-auto px-6 lg:px-8">
            <a
              href="/"
              className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-white/40 hover:text-[#EAB308] transition-colors mb-10"
              data-testid="cookies-back-link"
            >
              ← Volver al inicio
            </a>
            <div className="text-xs tracking-[0.3em] uppercase text-[#EAB308] mb-4">
              Marco Legal
            </div>
            <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight leading-none mb-4">
              Política de
              <br />
              <span className="text-white/40">Cookies</span>
            </h1>
            <p className="text-white/50 text-sm max-w-2xl mb-12 font-body">
              Información sobre el uso de cookies y tecnologías similares en el
              sitio web de PROXIMA LEAGUE, conforme a la LSSI-CE y al RGPD.
            </p>

            <div className="space-y-10">
              {SECTIONS.map((s, idx) => (
                <div key={s.title} data-testid={`cookies-section-${idx}`}>
                  <h2 className="font-heading text-base sm:text-lg text-white uppercase tracking-wide mb-3 flex items-center gap-3">
                    <span className="w-6 h-px bg-[#EAB308]" />
                    {s.title}
                  </h2>
                  <p className="text-white/65 font-body text-sm sm:text-base leading-relaxed whitespace-pre-line max-w-3xl">
                    {s.body}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-14 pt-6 border-t border-white/10 text-[10px] tracking-[0.25em] uppercase text-white/30">
              Última actualización · Junio 2026
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
